<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 21.6c2.5461 0 4.9879-1.0114 6.7882-2.8118C20.5886 16.9879 21.6 14.5461 21.6 12c0-2.54608-1.0114-4.98787-2.8118-6.78822C16.9879 3.41143 14.5461 2.4 12 2.4c-2.54608 0-4.98787 1.01143-6.78822 2.81178C3.41143 7.01213 2.4 9.45392 2.4 12c0 2.5461 1.01143 4.9879 2.81178 6.7882C7.01213 20.5886 9.45392 21.6 12 21.6Zm1.2-14.4c0-.31826-.1264-.62348-.3515-.84853C12.6235 6.12643 12.3183 6 12 6s-.6235.12643-.8485.35147c-.2251.22505-.3515.53027-.3515.84853V12c.0001.3182.1265.6234.3516.8484l3.3936 3.3948c.1115.1115.2439.1999.3895.2603.1457.0603.3018.0914.4595.0914s.3138-.0311.4595-.0914c.1456-.0604.278-.1488.3895-.2603.1115-.1115.1999-.2439.2603-.3895.0603-.1457.0914-.3018.0914-.4595s-.0311-.3138-.0914-.4595c-.0604-.1456-.1488-.278-.2603-.3895L13.2 11.5032V7.2Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 4c-2.12173 0-4.15656.84285-5.65685 2.34315C4.84285 7.84344 4 9.87827 4 12c0 1.0506.20693 2.0909.60896 3.0615.40204.9706.99132 1.8525 1.73419 2.5954.74286.7428 1.62478 1.3321 2.59538 1.7341C9.90914 19.7931 10.9494 20 12 20c1.0506 0 2.0909-.2069 3.0615-.609.9706-.402 1.8525-.9913 2.5954-1.7341.7428-.7429 1.3321-1.6248 1.7341-2.5954.4021-.9706.609-2.0109.609-3.0615 0-2.12173-.8429-4.15656-2.3431-5.65685C16.1566 4.84285 14.1217 4 12 4Zm-7.07107.92893C6.8043 3.05357 9.34784 2 12 2c2.6522 0 5.1957 1.05357 7.0711 2.92893C20.9464 6.8043 22 9.34784 22 12c0 1.3132-.2587 2.6136-.7612 3.8268-.5026 1.2133-1.2391 2.3157-2.1677 3.2443-.9286.9286-2.031 1.6651-3.2443 2.1677C14.6136 21.7413 13.3132 22 12 22c-1.3132 0-2.61358-.2587-3.82683-.7612-1.21326-.5026-2.31565-1.2391-3.24424-2.1677-.92858-.9286-1.66518-2.031-2.16773-3.2443C2.25866 14.6136 2 13.3132 2 12c0-2.65216 1.05357-5.1957 2.92893-7.07107ZM12 7c.5523 0 1 .44772 1 1v3.5858l2.7071 2.7071c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0l-3-3C11.1054 12.5196 11 12.2652 11 12V8c0-.55228.4477-1 1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
